import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { TextInput, SelectInput } from './FormElements';

// http://localhost:8000/rest/v1/zombie/user-submissions/?brand=el&approved=true&task_id=ad&phone=7655&user=admin

const Search = withFormik({
  validationSchema: Yup.object().shape({
    brand: Yup.string(),
    approved: Yup.string(),
    submissionResult: Yup.string(),
    task_id: Yup.string(),
    phone: Yup.string(),
    user: Yup.string(),
    country: Yup.string(),
  }),
  mapPropsToValues: ({ data }) => ({
    brand: data.brand,
    approved: data.approved,
    submissionResult: data.submissionResult,
    task_id: data.task_id,
    phone: data.phone,
    user: data.user,
    country: data.country,
  }),
  handleSubmit: async (payload, { props, setSubmitting, setErrors }) => {
    try {
      const errors = await props.handleSubmit(payload);
      setSubmitting(false);
      if (errors) {
        setErrors(errors);
      }
    } catch (e) {
      throw e;
    }
  },
  displayName: 'SearchForm',
});

const searchForm = (props) => {
  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    values,
  } = props;

  return (
    <form onSubmit={handleSubmit} className='login-form'>
      <Row>
        <Col>
          <TextInput
            id='phone'
            type='text'
            label='Phone'
            placeholder='Phone contains'
            value={values.phone}
            error={touched.phone && errors.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Col>
          <TextInput
            id='task_id'
            type='text'
            label='Task ID'
            placeholder='Task ID equals'
            value={values.task_id}
            error={touched.task_id && errors.task_id}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Col>
          <TextInput
            id='brand'
            type='text'
            label='Brand'
            placeholder='Brand starts with'
            value={values.brand}
            error={touched.brand && errors.brand}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Col>
          <TextInput
            id='country'
            type='text'
            label='Country'
            placeholder='Country starts with'
            value={values.country}
            error={touched.country && errors.country}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Col>
          <SelectInput
            id='submissionResult'
            type='text'
            label='Submission Result'
            placeholder='Submission Result'
            value={values.submissionResult}
            error={touched.submissionResult && errors.submissionResult}
            onChange={setFieldValue}
            onBlur={handleBlur}
            optionsData={{
              key: 'key',
              value: 'value',
              data: [
                { key: null, value: '--' },
                { key: 'approved', value: 'Approved' },
                { key: 'rejected', value: 'Rejected' },
                { key: 'softRejected', value: 'Soft Rejected' },
              ],
            }}
          />
        </Col>
        <Col>
          <TextInput
            id='user'
            type='text'
            label='Reviewed By'
            placeholder='email starts with'
            value={values.user}
            error={touched.user && errors.user}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Col>
        <Button
          style={{ height: '40px' }}
          type='submit'
          color='primary'
          disabled={!props.isValid || isSubmitting}
        >
          Filter
        </Button>
      </Row>
    </form>
  );
};

export const SearchForm = Search(searchForm);
